@if (ngControl?.control) {
<div class="androweb-form-group" [ngClass]="{'with-prefix': matIcon || iconSax, 'input-control-with-errors': ngControl.invalid && (ngControl.control.touched || showInputError)}">
  @if (label) {
  <label class="label-floating">
    {{ label }}
    @if (ngControl.control.errors?.required) { <small class="small-alert"> * </small> }
  </label>
  }

  <div class="input-group mb-1 mr-sm-2" [ngClass]="{'input-group-error-outline': ngControl.invalid && (ngControl.control.touched || showInputError)}">
    @if (matIcon || iconSax) {
    <div class="input-group-prepend">
      <div class="input-group-text" [ngStyle]="{'background-color': prependIconBackground}">
        @if (matIcon) { <mat-icon id="icon">{{ matIcon }}</mat-icon> }
        @if (iconSax) { <ng-icon [name]="iconSax"></ng-icon> }
      </div>
    </div>
    }
    <input [type]="type"
           [formControl]="ngControl.control | formControl"
           [placeholder]="placeHolder"
           [maxlength]="maxLength"
           [ngStyle]="{'text-transform': textTransform}"
           id="{{ label?.split(' ').join('-') + '-form-input' }}" />
  </div>

  @if (ngControl.control.errors?.required && (ngControl.control.touched || showInputError)) {
  <div class="flex-row flex-align-center">
    <mat-icon class="androweb-form-rule-red mb-0">info</mat-icon>
    <label class="label-floating">
      <small class="small-alert" id="required-error">
        This field is required
      </small>
    </label>
  </div>
  }

  @if (ngControl.control.errors?.pattern) {
  <div class="flex-row flex-align-center">
    <mat-icon class="androweb-form-rule-red mb-0">info</mat-icon>
    <label class="label-floating">
      <small class="small-alert">
        {{ patternError }}
      </small>
    </label>
  </div>
  }

  @if (ngControl.control.errors?.maxlength) {
  <div class="flex-row flex-align-center">
    <mat-icon class="androweb-form-rule-red mb-0">info</mat-icon>
    <label class="label-floating">
      <small class="small-alert">
        Maximum length is {{ ngControl?.control.errors.maxlength['requiredLength'] }} characters
      </small>
    </label>
  </div>
  }
</div>
}
